export default "__VITE_ASSET__rg2Yei5I__"